<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="project.id">
          <project-buttons :project="project"></project-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <project-form ref="projectForm"/>
            <project-tabs v-if="project && project.id"/>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="submit" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      :title="confirmation[type].title"
      :message="confirmation[type].message"/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProjectTabs from './ProjectTabs.vue';
import ProjectForm from './ProjectForm.vue';
import ProjectActions from './ProjectActions';
import ProjectButtons from './ProjectButtons.vue';
import { _SAVE_PROJECT_SUCCESS_, OPTIONS_CONFIRMATION_MODAL, _OPEN_CONFIRMATION_ } from './ProjectModel';

export default {
  name: 'project-page',
  mixins: [ProjectActions],
  props: {
    project: {
      type: Object,
      default() {
        return { id: null };
      },
    },
  },
  components: {
    Loader,
    ProjectForm,
    ProjectTabs,
    ProjectButtons,
    ConfirmationModal,
  },
  data() {
    return {
      type: 'delete',
      loading: false,
      confirmation: OPTIONS_CONFIRMATION_MODAL,
      selectProject: null,
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
    save() {
      this.$refs.projectForm.save();
      this.close();
    },
    submit() {
      this.$refs.projectForm.submit();
      Events.$on(_SAVE_PROJECT_SUCCESS_, project => {
        this.$router.push(`/admin/obras/${project.id}/1`);
      });
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_OPEN_CONFIRMATION_, ({ project, type }) => {
      this.selectProject = project;
      this.type = type;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
